import styled from 'styled-components'

export const MainContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--green);
  padding: 12px 16px;
  white-space: nowrap;
  transform: translate(calc(-100% + 62px), calc(100% + 12px));

  & p {
    color: white;
  }
`

export const Triangle = styled.svg`
  fill: var(--green);
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-40px, -100%);
`
